import validator from 'validator'
import { Map, List } from 'immutable'

function CheckIsValidDomain(domain) {
  var re = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/)
  return domain.match(re)
}

export default function (values, rules = {}) {
  let errors = Map()

  let setError = function (name, error) {
    let cur = errors.get(name, List())
    if (cur.indexOf(error) === -1) {
      errors = errors.set(name, cur.push(error))
    }
  }

  for (let name in rules) {
    let ruleSet = rules[name]
    let namePath = name.split('.')
    let value = values.getIn(namePath, '')
    for (let i = 0; i < ruleSet.length; i++) {
      let rule = ruleSet[i]
      let parts = rule.split(':')
      switch (parts[0]) {
        case 'required':
          if (!value) {
            setError(name, 'Field is required')
          }
          break
        case 'not':
          let items = parts[1].split(',')
          if (items.length && items.indexOf(value) !== -1) {
            setError(name, 'Field is already taken')
          }
          break
        case 'min':
          if (value && value.length < parts[1]) {
            setError(name, `Field must be atleast ${parts[1]} long`)
          }
          break
        case 'max':
          if (value && value.length > parts[1]) {
            setError(name, `Field can be only ${parts[1]} long`)
          }
          break
        case 'email':
          if (value && !validator.isEmail(value)) {
            setError(name, 'Field must be valid email')
          }
          break
        case 'date':
          if (value && !validator.isDate(value)) {
            setError(name, 'Field must be valid date')
          }
          break
        case 'url':
          if (
            value &&
            !_.startsWith(value, '/') &&
            !validator.isURL(value, {
              require_protocol: true,
            })
          ) {
            setError(name, 'Field must be valid url or relative')
          }
          break
        case 'same':
          if (value !== values.get(parts[1])) {
            setError(name, `Field must same as ${parts[1]}`)
          }
          break
        case 'domain':
          if (value && !CheckIsValidDomain(value)) {
            setError(name, 'Field must be valid domain')
          }
          break
        case 'creditcard':
          if (value && !validator.isCreditCard(value)) {
            setError(name, 'Field must be credit card')
          }
          break
        case 'expiry':
          if (value) {
            let valid = true
            let split = value.split('/').map(s => parseInt(s.trim()))

            if (split.length === 2) {
              let month = split[0]
              let year = split[1]
              let currentYear = new Date().getFullYear()
              let currentMonth = new Date().getMonth() + 1

              if (month < 1 || month > 12) {
                valid = false
              }

              if (year < currentYear) {
                valid = false
              } else if (year === currentYear && month < currentMonth) {
                valid = false
              }
            } else {
              valid = false
            }

            if (!valid) {
              setError(name, 'Field must be MM / YYYY')
            }
          }
          break
      }
    }
  }

  return errors
}
